import React from "react";

import { TextCenter } from "src/common/components/TextAlign";

import ctPng from "./ct.png";
import endokrinPng from "./endokrin.png";
import nefrologiaPng from "./nefrologia.png";
import vizeletPng from "./vizelet.png";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>
			A verzióban bővítettük az elérhető űrlapok listáját, ezáltal további
			adatok felvitele lehetséges a páciensekhez.
		</h1>
		<p>Az alábbi űrlapokat hoztuk létre vagy módosítottuk:</p>
		<ol>
			<li>
				Bővítettük az <b>Anyagcsere betegség</b> űrlapon megadható
				betegségek listáját. Az űrlapot ezentúl Endokrin és anyagcsere
				betegség néven találják meg a listában
				<TextCenter>
					<img src={endokrinPng} width="90%" />
				</TextCenter>
			</li>
			<li>
				Új <b>Maradék vizelet mennyiség</b> nevű űrlappal bővült a
				Laborvizsgálatok csoport
				<TextCenter>
					<img src={vizeletPng} width="90%" />
				</TextCenter>
			</li>
			<li>
				Új <b>Koponya CT / MR / angiográfia</b> nevű űrlappal bővült a
				Képalkotó vizsgálatok csoport
				<TextCenter>
					<img src={ctPng} width="90%" />
				</TextCenter>
			</li>
			<li>
				Új <b>Transzplantációs nefrológia</b> nevű űrlappal bővült a
				Konzíliumok csoport
				<TextCenter>
					<img src={nefrologiaPng} width="90%" />
				</TextCenter>
			</li>
		</ol>
	</section>
);
